import {
  SET_SEARCH_TEXT,
} from './mutations.type';

export default {
  [SET_SEARCH_TEXT](state, data) {
    state.searchText = data;
  },
};
